import React, { useCallback } from 'react'
import styled from 'styled-components'

import { inputStyles } from '../TextInput'

const Wrapper = styled.div`
  position: relative;
  width: ${({ $width }) => $width};
`

const InputComponent = styled.textarea`
  ${inputStyles}
  resize: none;
  height: 23vh;
  width: 100%;
  padding: 12px 16px !important;
  border-radius: 20px;
  -webkit-appearance: none;
`

const TextArea = ({ value, onChange, width, placeholder, error, type, children, ...props }) => {
  const handleChange = useCallback((e) => {
    let v = e.target.value
    onChange(v)
  }, [])

  return (
    <Wrapper $width={width} className="text-area__container">
      <InputComponent className="text-area__input" type={type} placeholder={placeholder} onChange={handleChange} value={value} {...props} />
      {children}
    </Wrapper>
  )
}

export default TextArea
